import { render, staticRenderFns } from "./WagesReport.vue?vue&type=template&id=4403b061&"
import script from "./WagesReport.vue?vue&type=script&lang=js&"
export * from "./WagesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4403b061')) {
      api.createRecord('4403b061', component.options)
    } else {
      api.reload('4403b061', component.options)
    }
    module.hot.accept("./WagesReport.vue?vue&type=template&id=4403b061&", function () {
      api.rerender('4403b061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/WagesReport.vue"
export default component.exports